module.exports = __webpack_public_path__ + "static/media/send.cb9df63a.svg";